import React from 'react'
import {ButtonFormStyled} from './buttonFormStyles'

// progreso (opcional): "enviando" llena el botón como una barra de carga;
// "ok" lo completa en verde. Sin progreso, el botón es el de siempre.
const ButtonForm = ({type,children, disabled, progreso }) => {

return (
    <ButtonFormStyled
      type={type}
      disabled={disabled}
      $progreso={progreso}
      aria-busy={progreso === "enviando" || undefined}
    >
      {children}
    </ButtonFormStyled>
  )
}

export default ButtonForm
